import { get, isEmpty, map, sumBy } from 'lodash';

import { createSelector } from 'reselect';
import { dateFormats } from '../../common/constants/chart-options';
import { parseTime } from '../../utils/chart-utils';

// DMARC Effectiveness
export const rawDmarcEffectivenessSelector = state => get( state, 'dmarc.effectiveness', {} );
export const dmarcEffectivenessIsLoadingSelector = state => get( state, 'dmarc.effectivenessIsLoading', false );
export const dmarcEffectivenessIsLoadedSelector = state => !get( state, 'dmarc.effectivenessIsLoading', false ) && !isEmpty( get( state, 'dmarc.effectiveness', {} ) );
export const prevDmarcEffectivenessParamsSelector = state => get( state, 'dmarc.effectivenessParams' );

export const effectTableIsExportingGridToCSV = state => get( state, 'exportReport.isExportingCSV.effectiveness', false );

export const flattenedDmarcEffectivenessSelector = createSelector( rawDmarcEffectivenessSelector, ( rawData ) => {
    return map( rawData, ( row, date ) => {
        const { delivered, rejected, total } = row;

        let blockRate = 0;
        let deliverRate = 0;

        if( row.total > 0 ){
            blockRate = ( ( row.rejected / row.total ) * 100 );
            deliverRate = ( ( row.delivered / row.total ) * 100 );
        }

        return {
            blockCount: rejected,
            blockRate: blockRate.toFixed( 2 ),
            date,
            deliverCount: delivered,
            deliverRate: deliverRate.toFixed( 2 ),
            total
        };
    } );
} );

export const dmarcEffectivenessVisSelector = createSelector( rawDmarcEffectivenessSelector, ( rawData ) => {
    let x =  map( rawData, ( row, date ) => {
        /*
         *  delivered: 986
         *  rejected: 121213
         *  total: 122199
         */
        let blockRate = 0;
        if( row.total > 0 ){
            blockRate = ( ( row.rejected / row.total ) * 100 );
        };
        return {
            blockRate: blockRate,
            date: parseTime( dateFormats.STANDARD_DATE )( date ),
            total: row.total,
        };
    } );
    return x;
} );

export const avgDmarcBlockRateSelector = createSelector(
    flattenedDmarcEffectivenessSelector,
    ( dmarcEffectivenessData ) => {
        const sumPass = sumBy( dmarcEffectivenessData, 'blockCount' );
        const sumTotal = sumBy( dmarcEffectivenessData, 'total' );
        const avg = ( sumPass / sumTotal ) * 100 || 0;

        return avg.toFixed( 2 );
    }
);
